import { ObjectId } from '@racemap/sdk/schema/base';
import { capitalize } from '@racemap/utilities/functions/utils';
import type { Location } from 'react-router';
import shortHash from 'shorthash2';

declare const __GTAG_ID__: string;
const gtagId = __GTAG_ID__ || process.env.GTAG_ID;

export function initGoogleAnalytics() {
  if (gtagId === undefined || gtagId === '') return;
  gtag('config', gtagId);
}

export function sendAnalyticsEvent(
  eventName: Gtag.EventNames | string,
  eventParams?: Gtag.EventParams | Gtag.ControlParams | Gtag.CustomParams,
) {
  gtag('event', eventName, eventParams);
}

const getAggregatedTitle = (pathname: string) => {
  const parts = pathname.split('/').filter((part) => part.length > 0);
  return `Racemap | Admin | ${parts
    .filter((p) => p !== 'admin')
    .map((p) => (ObjectId.isValid(p) ? '#' : capitalize(p)))
    .join(' | ')}`;
};

export function sendPageViewEvent(location: Location) {
  const pathname = location.pathname;
  const titleFull = `Racemap | Admin | ${location.pathname.replace('/admin/', '').replace(/\//g, ' | ')}`;
  const titleAggregated = getAggregatedTitle(pathname);
  console.log('Page view event:', location.pathname, '---', titleAggregated);

  gtag('event', 'page_view', {
    page_path: pathname,
    page_title: titleAggregated,
    page_title_full: titleFull,
  });
}

export function sendErrorEvent(error: unknown, fatal = false) {
  const errorName = error instanceof Error ? error.name : 'UnknownError';
  const errorMessage = error instanceof Error ? error.message : 'UnknownError';
  const errorHash = shortHash(errorMessage);

  gtag('event', 'exception', {
    description: `${errorName} - ${errorHash}`,
    fatal,
  });
}
